import { useEffect } from 'react';
import { registerGlobalServerError, useServerError } from './ServerErrorOverlay';

/**
 * Bridges the ServerErrorContext (React) with the global triggerServerError function
 * used by the HTTP client (which runs outside React's tree).
 */
export function ServerErrorBridge() {
  const { show } = useServerError();

  useEffect(() => {
    registerGlobalServerError(show);
    return () => {
      registerGlobalServerError(null as any);
    };
  }, [show]);

  return null;
}
